import { gamePortalPagesStateService } from 'state/game-portal-pages.state.service';

import { useObservable } from '../observable';

export const useGamePortalPagesState = () => {
  const openBlockIndex = useObservable(
    gamePortalPagesStateService.openBlockIndex
  );
  const openItemIndex = useObservable(
    gamePortalPagesStateService.openItemIndex
  );
  const storeOffers = useObservable(
    gamePortalPagesStateService.storeOffers
  );

  return {
    openBlockIndex,
    setOpenBlockIndex: gamePortalPagesStateService.setOpenBlockIndex,
    openItemIndex,
    setOpenItemIndex: gamePortalPagesStateService.setOpenItemIndex,
    storeOffers,
    setStoreOffers: gamePortalPagesStateService.setStoreOffers
  };
};

